exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.month-controls {\n    display: flex;\n    justify-content: space-between;\n}\n.month-controls button {\n    font-size: large;\n}\n.month-controls span {\n    display: inline-block; \n    text-align: center; \n    margin: 0 10px;\n}\n.available-percentage {\n    color: #C1CD23;\n}\n.on-request-percentage {\n    color: gold;\n}\n.closed-full-month-percentage {\n    color: blue;\n}\n.none-available {\n    color: #F15C61;\n}\n.quick-select {\n    max-width: 20%;\n}\n.quick-select button {\n    max-width: 50px;\n}\n", ""]);

// exports
